import React from 'react';
import './Style.css';
import { Link } from 'react-router-dom';

const Menu = () => {
    return (
        <>
            <div className="wrap-1 navBar">
                <div className="container">
                    <div className="row">
                        <div className="col-2 col-m-4"><h2 className='white logo'>Mock API</h2></div>
                        <div className="col-2 col-m-4">
                            <nav>
                                <Link to="/" className='link'>Home</Link>
                            </nav>
                        </div>
                        <div className="col-2 col-m-4">
                            <nav>
                                <Link to="/show" className='link'>Show</Link>
                            </nav>
                        </div>
                        <div className="col-2 col-m-4">
                            <nav>
                                <Link to="/update" className='link'>Update</Link>
                            </nav>
                        </div>
                        <div className="col-2 col-m-4">
                            <nav>
                                <Link to="/delete" className='link'>Delete</Link>
                            </nav>
                        </div>

                        <div className="col-2 col-m-4">
                            <nav>
                                <Link to="/post" className='link'>Post</Link>
                            </nav>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Menu;